"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.willHaveCoverageRSExtended = void 0;
const lookups_1 = require("@ourbranch/lookups");
function willHaveCoverageRSExtended({ roofType, roofAge, state }) {
    return ((['AF', 'AR', 'C'].includes(roofType) && roofAge <= (lookups_1.roofSurfacesExtendedCompositionMaxAge[state] || 15)) ||
        (['SL', 'ST', 'TN', 'CL', 'CO', 'MI', 'CP', 'CP', 'M', 'T', 'S'].includes(roofType) && roofAge <= 20) ||
        roofAge <= 10);
}
exports.willHaveCoverageRSExtended = willHaveCoverageRSExtended;
//# sourceMappingURL=will-have-coverage-rs-extended.js.map